import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import { ReactNode } from "react";
import { renderPlaceholderValue } from "./PlaceholderValueFormatter";

/**
 * Pass this as `tokens` while the real values are still being loaded: the
 * placeholders render ••• instead of the blank an unknown token gets. It is
 * recognised by identity, so it must be this very object.
 */
export const LOADING_TOKEN_VALUES: TokenValues = Object.freeze({});

export const offerPlaceholderResolver = (tokenValues: TokenValues = {}) => {
  const loadingPlaceholder = tokenValues === LOADING_TOKEN_VALUES;
  return (placeholders: string[]): NonNullable<ReactNode> =>
    placeholders.map((placeholder) =>
      renderPlaceholderValue(
        placeholder,
        tokenValues[placeholder],
        loadingPlaceholder
      )
    );
};
